<template>
    <v-dialog width="700px" v-model="dialog">

        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                v-on="on"
            ><v-icon left>mdi-plus</v-icon>Add Time Sheet
            </v-btn>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Add a New Time Sheet</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-row align="stretch">
                    <!-- right panel -->
                    <v-col>
                        <v-form ref="form">
                            <v-row>
                                
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete
                                        prepend-icon="mdi-map-marker"
                                        label="Select Restaurant"
                                        item-text="name"
                                        item-value="id"
                                        v-model="restaurant_id"
                                        :items="restaurant_list"
                                        :error-messages="selectAreaErrors"
                                        @blur="$v.restaurant_id.$touch()"
                                        required
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete
                                        prepend-icon="mdi-account"
                                        label="Select driver"
                                        item-text="full_name"
                                        item-value="id"
                                        v-model="driver_id"
                                        :disabled="!restaurant_id"
                                        :items="driverListSearched"
                                        :error-messages="selectDriverErrors"
                                        @blur="$v.driver_id.$touch()"
                                        required
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-menu
                                        v-model="timesheet_date_picker"
                                        transition="scale-transition"
                                        :close-on-content-click="false"
                                        :nudge-width="200"
                                        max-width="346px"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                            v-on="on"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-calendar"
                                            clearable
                                            outlined
                                            label="Date*"
                                            hint="22/11/2019"
                                            required
                                            v-model="period_date"
                                            :error-messages="periodDateErrors"
                                            @input="$v.period_date.$touch()"
                                            @blur="$v.period_date.$touch()"
                                            autocomplete="off"
                                        ></v-text-field>
                                        </template>

                                        <v-card max-width="346px">
                                        <v-date-picker
                                            v-model="period_date_selected"
                                            scrollable
                                            actions
                                            full-width
                                            first-day-of-week="1"
                                            :title-date-format="getPeriodDateText"
                                            v-on:click:date="periodDateSelect"
                                            :max="period_date_max"
                                        ></v-date-picker>
                                        </v-card>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete
                                        class="hide-time-picker-indicator"
                                        type="text"
                                        menu-props="auto, overflowY"
                                        clear-icon="mdi-close"
                                        prepend-icon="mdi-clock-outline"
                                        clearable
                                        outlined
                                        label="Start Time*"
                                        hint="Example: 08:00"
                                        required
                                        v-model="start_time"
                                        :items="timeList"
                                        item-text="name"
                                        item-value="value"
                                        :error-messages="startTimeErrors"
                                        open-on-clear
                                        v-on:focus="onStartTimeFocused"
                                        v-on:input="onStartTimeChanged"
                                        v-on:blur="onStartTimeBlur"
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete
                                        class="hide-time-picker-indicator"
                                        type="text"
                                        menu-props="auto, overflowY"
                                        clear-icon="mdi-close"
                                        prepend-icon="mdi-clock-outline"
                                        clearable
                                        outlined
                                        label="Finish Time*"
                                        hint="Example: 18:30"
                                        required
                                        v-model="finish_time"
                                        :items="timeList"
                                        item-text="name"
                                        item-value="value"
                                        :error-messages="finishTimeErrors"
                                        open-on-clear
                                        v-on:focus="onFinishTimeFocused"
                                        v-on:input="onFinishTimeChanged"
                                        v-on:blur="onFinishTimeBlur"
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12" class="pb-0">
                                    <v-textarea
                                        outlined
                                        label="Comment"
                                        v-model="comment"
                                    ></v-textarea>
                                </v-col>

                                <v-col v-if="area_selected" sm="12" class="pb-0">
                                    <v-row>
                                        <v-col cols="12" sm="6" style="height: 80px"
                                            class="d-flex flex-column justify-space-between pa-0 pr-3">
                                            <span class="adjustment-type">Mon – Thurs Pay/Hr*</span>
                                            <!--<span class="adjustment">$200</span>-->
                                            <div class="adjustment">
                                            <!-- <span class="currency">&#163</span>-->
                                                <v-text-field
                                                        prefix="£"
                                                        readonly
                                                        outlined
                                                        class="adjustment-input"
                                                        :value="restaurant_selected.standard_pay ? restaurant_selected.standard_pay : area_selected.standardPayRate"
                                                        required
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="6" style="height: 80px"
                                            class="d-flex flex-column justify-space-between pa-0 pl-3">
                                            <span class="adjustment-type">Fri-Sun Pay/Hr*</span>
                                            <div class="adjustment">
                                                <v-text-field
                                                        prefix="£"
                                                        readonly
                                                        outlined
                                                        class="adjustment-input"
                                                        :value="restaurant_selected.weekend_pay ? restaurant_selected.weekend_pay : area_selected.weekendPayRate"
                                                        required
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="submit"
                                ><v-icon left>mdi-upload</v-icon>Create Time Sheet</v-btn>
                                <v-btn
                                        class="mr-4"
                                        :loading="localLoading"
                                        depressed
                                        @click="clear"
                                ><v-icon left>mdi-rotate-left</v-icon>Clear</v-btn>
                                <v-btn
                                        class="mr-4 warning"
                                        :loading="localLoading"
                                        depressed
                                        @click="dialog=false"
                                ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                            </div>

                        </v-form>
                    </v-col>
                    <!--/ right panel -->
                </v-row>
            </v-card-text>
        </v-card>
        
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex';
import moment from 'moment';
import { STATUS_PENDING, STATUS_PROGRESS_SUBMITED } from '../../store/timesheets';
import { DATE_RANGE_HELPERS } from '../../store/shifts';
import * as _ from 'lodash'

export default {
    mixins: [validationMixin],
    name: "NewTimesheetModal",
    // props: [],
    validations: {
        restaurant_id: { required },
        driver_id: { required },
        period_date: { required },
        start_time: { required,/* maxLength: maxLength(10)*/ },
        finish_time: { required },
        comment: { }
    },
    data: () => ({
        /*valid: false,*/
        readOnly: false,
        localLoading: false,
        dialog: false,
        period_date_max: moment().format('YYYY-MM-DD'),
        menu_date_picker: false,
        timesheet_date_picker: false,
        period_date_selected: null,
        restaurant_selected: void 0,
        area_selected: void 0,
        // -- form fields
        restaurant_id: void 0,
        driver_id: void 0,
        period_date: void 0,
        start_time: void 0,
        finish_time: void 0,
        comment: void 0,
        start_time_was_clean: false,
        finish_time_was_clean: false,
    }),
    updated() {
        // --
    },
    watch: {
        period_date: function(period_date_new, old) {
            if (old != period_date_new && /\d\d\/\d\d\/\d\d\d\d/.test(period_date_new)) { // check is date valid format
                this.$data.period_date_selected = moment(period_date_new, "DD/MM/YYYY").format('YYYY-MM-DD');
            }
        },
        restaurant_id: function(restaurant_id_new) {
            this.$data.restaurant_selected = _.find(this.restaurant_list, p => +p.id == +restaurant_id_new);
            if (!this.$data.restaurant_selected) {
                return; // exit
            }

            this.$data.area_selected = _.find(this.areas, p => +p.id == +this.$data.restaurant_selected.area_id);
        }
    },
    computed: {
        ...mapGetters(['areas', 'timeList']),
        driver_list() {
            return this.$store.getters.drivers;
        },
        restaurant_list() {
            return this.$store.getters.restaurants;
        },
        driverListSearched() {
            if (!this.$data.restaurant_id) { // restaurant not selected
                return [];
            }

            let restaurant = _.find(this.restaurant_list, p => +p.id == +this.$data.restaurant_id);

            if (!restaurant) {
                return [];
            }

            let drivers = _.filter(this.driver_list, driver => {
                if (driver.area_ids.length == 0) {
                    return true; // driver not assigned to any area
                }

                let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
                if (driver_area_ids.indexOf(restaurant.area_id) === -1) {
                    return false;
                }

                // check driver assigned to restaurant
                if (driver.restaurant_ids.length == 0) {
                    return true; // driver not assigned to any restaurant
                }

                let driver_restaurant_item = _.find(driver.restaurant_ids, p => p.restaurant_id == restaurant.id);
                if (driver_restaurant_item) {
                    return true;
                }

                return false;
            });

            return drivers;
        },
        selectDriverErrors () {
            const errors = [];
            if (!this.$v.driver_id.$dirty) {
                return errors;
            }
            !this.$v.driver_id.required && errors.push('Driver is required');
            return errors
        },
        selectAreaErrors () {
            const errors = [];
            if (!this.$v.restaurant_id.$dirty) {
                return errors;
            }
            !this.$v.restaurant_id.required && errors.push('Area is required');
            return errors
        },
        periodDateErrors () {
            const errors = [];
            if (!this.$v.period_date.$dirty) {
                return errors;
            }
            !this.$v.period_date.required && errors.push('Date is required.')
            !moment(this.$data.period_date, "DD/MM/YYYY").isValid() && errors.push('Date invalid format.')
            return errors
        },
        startTimeErrors () {
            const errors = [];
            if (!this.$v.start_time.$dirty) {
                return errors;
            }
            !this.$v.start_time.required && errors.push('Start Time is required.')
            !moment(this.$data.start_time, "HH:mm").isValid() && errors.push('Start Time invalid format.')
            return errors
        },
        finishTimeErrors () {
            const errors = [];
            if (!this.$v.finish_time.$dirty) {
                return errors;
            }
            !this.$v.finish_time.required && errors.push('Start Time is required.')
            !moment(this.$data.finish_time, "HH:mm").isValid() && errors.push('Finish Time invalid format.')
            return errors
        },
    },

    methods: {
        submit () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                /**
                 * if paste in weekday or from weekday or into another restaurant(area)
                 *  then recalculate `cost_per_hour` and `cost_total` 
                 **/
                //-- calc `cost_per_hour`
                let restaurant_item = _.find(this.restaurant_list, p => +p.id == +this.$data.restaurant_id);
                let area_selected = _.find(this.areas, p => p.id == restaurant_item.area_id);
                let cost_per_hour = this.$data.restaurant_selected.standard_pay ? this.$data.restaurant_selected.standard_pay : area_selected.standardPayRate;
                // check date is weekend, then get weekend rate
                let shift_date = moment(this.$data.period_date, "DD/MM/YYYY");
                if(shift_date.isoWeekday() === 5 || shift_date.isoWeekday() === 6 || shift_date.isoWeekday() === 7) {
                    cost_per_hour = this.$data.restaurant_selected.weekend_pay ? this.$data.restaurant_selected.weekend_pay : area_selected.weekendPayRate;
                }

                const time_sheet_data = {
                    shift_id: null,
                    restaurant_id: this.$data.restaurant_id,
                    driver_id: this.$data.driver_id,
                    status: STATUS_PENDING,
                    status_progress: STATUS_PROGRESS_SUBMITED,
                    period_date: moment(this.$data.period_date, "DD/MM/YYYY").format('YYYY-MM-DD'),
                    start_time: this.$data.start_time,
                    finish_time: this.$data.finish_time,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: cost_per_hour,
                    cost_bonus: 0,
                    const_fuel_bonus: 0,
                    cost_extra_bonus: 0,
                    fuel_bonus_0: 0,
                    fuel_bonus_3: 0,
                    fuel_bonus_6: 0,
                    // cost_total: 0, //!
                    comment: this.$data.comment,
                };

                // calc cost total
                let total_hours = this.getShiftHours(time_sheet_data);
                time_sheet_data.cost_total = (+time_sheet_data.cost_per_hour *  +total_hours);

                // create new time sheet
                this.localLoading = true;
                this.$store.dispatch('createNewTimesheet', time_sheet_data).then(() => {
                }).finally(() => {
                    this.localLoading = false;
                    this.clear(); // reset form
                    this.dialog = false; // close dialog
                });
            }
        },
        periodDateSelect: function() {
            this.$data.period_date = moment(this.$data.period_date_selected, 'YYYY-MM-DD').format("DD/MM/YYYY");
            this.$data.timesheet_date_picker = false; // hide calendar
        },
        getPeriodDateText: function (period_date_selected) {
            return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
        },
        getShiftHours: function(shift_item) {
            return DATE_RANGE_HELPERS.getShiftHours(shift_item);
        },
        clear () {
            this.$v.$reset();
            this.area_selected = void 0;
            this.restaurant_id = void 0;
            this.driver_id = void 0;
            this.start_time = '';
            this.finish_time = '';
            this.period_date = void 0;
        },
        // -- select current time on click
        onStartTimeFocused: function() {
            if (!this.start_time) {
                this.start_time = this.timeToApproximation(moment().format('HH:mm'));
                this.start_time_was_clean = true;
            }
        },
        onStartTimeChanged: function() {
            this.$v.start_time.$touch();
            this.start_time_was_clean = false;
        },
        onStartTimeBlur: function () {
            if (this.start_time_was_clean) {
                this.start_time = void 0;
            }
            this.$v.start_time.$touch(); // fire validation
        },
        onFinishTimeFocused: function() {
            if (!this.finish_time) {
                this.finish_time = this.timeToApproximation(moment().format('HH:mm'));
                this.finish_time_was_clean = true;
            }
        },
        onFinishTimeChanged: function() {
            this.$v.finish_time.$touch();
            this.finish_time_was_clean = false;
        },
        onFinishTimeBlur: function () {
            if (this.finish_time_was_clean) {
                this.finish_time = void 0;
            }
            this.$v.finish_time.$touch(); // fire validation
        },
        // -- END select current time on click
        timeToApproximation: function(time_src) {
            let time_src_m = moment(time_src, "HH:mm:ss");
            if (!time_src_m.isValid()) {
                return time_src;
            }

            let time_item = _.find(this.timeList, p => {
                let time_item = moment(p.value, "HH:mm");
                let time_approximation = (time_item - time_src_m) / (1000 * 60 * 60)
                return time_approximation > -0.125;
            });

            if (time_item) {
                return time_item.value;
            }

            return time_src;
        },
    },
}
</script>

<style scoped>

</style>